import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/search/search_ic.png';
import _imports_1 from '@/assets/icon/search/delect.png';
import _imports_2 from '@/assets/icon/hot.png';
const _withScopeId = n => (_pushScopeId("data-v-0c854229"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "searchPage" };
const _hoisted_2 = { class: "search-top flex-c" };
const _hoisted_3 = { class: "search flex-c" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "search-icon",
    src: _imports_0,
    alt: "搜索"
}, null, -1));
const _hoisted_5 = ["onKeydown"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = {
    key: 0,
    class: "history-box"
};
const _hoisted_9 = { class: "history-title flex-c" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "历史搜索", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "delect-icon",
    src: _imports_1
}, null, -1));
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = { class: "history-list flex-c font-28" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "hot-box" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "hot-title flex-c" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "热门搜索"),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "hot-icon",
        src: _imports_2
    })
], -1));
const _hoisted_17 = { class: "hot-list" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = { class: "level" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "search-icon",
    src: _imports_0,
    alt: "搜索",
    linearDown: ""
}, null, -1));
const _hoisted_22 = ["innerHTML"];
const _hoisted_23 = { class: "search-result" };
const _hoisted_24 = { class: "empty font-28" };
import { getHot, getHistory, suggestSearch, resetHistory, historyAdd } from '@api/search';
import { getDepId } from '@/api/user';
import searchListItem from '@/components/list/searchListItem.vue';
import { getUserId, isLogin, userLogin, appPort, jumpModuleApp, hiddenAppNavBar, prevPageView } from '@/widget';
import { useRoute, useRouter } from 'vue-router';
import { ref, watch, onMounted, nextTick, onUnmounted } from 'vue';
import { Toast } from 'vant';
import { hostPath } from '@/public/utils/basePath';
import { debounce } from 'lodash-es';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const isApp = appPort();
        const searchText = ref(String(route.query.kw || ''));
        const isSearchFocus = ref();
        const showList = ref(false);
        let userId = getUserId();
        const hotList = ref([]);
        const historyList = ref({});
        const isHistory = ref(false);
        const suggestList = ref([]);
        const isEmpty = ref(false);
        const childRef = ref();
        const inputRef = ref();
        watch(() => searchText.value, n => {
            if (n) {
                isSearchFocus.value = false;
                getSuggest();
                // addQuery()
            }
            else {
                isSearchFocus.value = true;
            }
        });
        // 获取科室信息
        let depId = Number(localStorage.getItem('search_depid')) || 0;
        const searchFocus = () => {
            isSearchFocus.value = true;
        };
        /* 更新路由参数 */
        let query = route.query || {};
        const addQuery = (isClose) => {
            router.replace({
                path: '/search',
                query: {
                    ...query,
                    kw: !isClose ? searchText.value : '',
                    depId: depId
                }
            });
        };
        /* 获取搜索建议数据 */
        const getSuggest = debounce(() => {
            isEmpty.value = false;
            suggestSearch({
                target: searchText.value,
                departmentId: depId
            }).then(res => {
                if (res.code === 200) {
                    suggestList.value = res.data.keywords;
                    if (res.data.length === 0) {
                        isEmpty.value = true;
                    }
                }
            });
        }, 150, { leading: true, trailing: false });
        const suggestJump = item => {
            searchText.value = item.replace(/<em>|<\/em>/g, '');
            search();
        };
        const searchInput = debounce(() => {
            isSearchFocus.value = false;
            if (!searchText.value) {
                isSearchFocus.value = true;
            }
        }, 300, { leading: true, trailing: false });
        /* 关闭/取消 */
        const closeSearch = () => {
            searchText.value = '';
            showList.value = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            getData();
            addQuery(true);
        };
        /* 返回上一页 */
        const backTo = () => {
            prevPageView();
            localStorage.removeItem('searchData');
        };
        const search = () => {
            if (!isLogin) {
                userLogin();
                return;
            }
            isSearchFocus.value = false;
            if (!searchText.value) {
                Toast('请输入搜索关键字');
                return;
            }
            historyAdd({
                target: searchText.value
            }).then((res) => {
                console.log('搜索历史-追加成功');
            });
            if (showList.value === true) {
                addQuery();
                // childRef.value.getDatas(true)
            }
            else {
                showList.value = true;
            }
        };
        const getData = () => {
            // 获取热门搜索
            getHot({
                params: { userId },
                query: {
                    departmentId: depId
                }
            }).then((res) => {
                if (res.code == 200) {
                    hotList.value = res.data;
                }
            });
            // 获取搜索历史
            getHistory().then((res) => {
                if (res.code == 200) {
                    historyList.value = res.data;
                    isHistory.value = historyList.value.words.length > 0 ? true : false;
                }
            });
        };
        /* 重置历史搜索 */
        const resetBtn = () => {
            resetHistory().then((res) => {
                if (res.code == 200) {
                    Toast('重置成功');
                    getData();
                }
            });
        };
        const hotJump = item => {
            var url = '';
            if (isApp) {
                /* 专辑暂不处理 */
                /* if (item.keyType == 1) {
                } */
                var data = {};
                /* 直播 */
                if (item.keyType == 2) {
                    data = {
                        dataId: item.keyDataId,
                        typeId: 'live_stream_detail',
                        url: `${hostPath}/live/broadcast/${item.keyDataId}`
                    };
                }
                else if (item.keyType == 3) {
                    /* 商品 */
                    data = {
                        dataId: item.keyDataId,
                        typeId: 'mall_detail',
                        url: `${hostPath}/mall/detail?productId=${item.keyDataId}`
                    };
                }
                else if (item.keyType == 4) {
                    /* 会员 */
                    data = {
                        typeId: 'vip_member_open',
                        url: `${hostPath}/open_vip`
                    };
                }
                else if (item.keyType == 5) {
                    /* 学习班 */
                    data = {
                        dataId: item.keyDataId,
                        typeId: 'vip_member_open',
                        url: `${hostPath}/study/detail?id=${item.keyDataId}`
                    };
                }
                else if (item.keyType == 6) {
                    /* 训练营 */
                    data = {
                        dataId: item.keyDataId,
                        typeId: 'operation_detail'
                    };
                }
                else if (item.keyType == 7) {
                    /* 共学营 */
                    data = {
                        dataId: item.keyDataId,
                        typeId: 'h5',
                        url: `${hostPath}/learn/courseguide/train/${item.keyDataId}`
                    };
                }
                else if (item.keyType == 8) {
                    /* 文章 */
                    data = {
                        dataId: item.keyDataId,
                        typeId: 'article_detail',
                        url: `${item.url}`
                    };
                }
                jumpModuleApp(data);
            }
            else {
                if (item.keyType == 2) {
                    location.assign(`${hostPath}/live/broadcast/${item.keyDataId}`);
                }
                else if (item.keyType == 3) {
                    location.assign(`${hostPath}/mall/detail?productId=${item.keyDataId}`);
                }
                else if (item.keyType == 4) {
                    location.assign(`${hostPath}/open_vip`);
                }
                else if (item.keyType == 5) {
                    location.assign(`${hostPath}/study/detail?id=${item.keyDataId}`);
                }
                else if (item.keyType == 6) {
                    location.assign(`${hostPath}/training/detail?id=${item.keyDataId}`);
                }
                else if (item.keyType == 7) {
                    router.push({
                        name: 'courseGuidePage',
                        params: {
                            type: 'train',
                            id: item.keyDataId
                        }
                    });
                }
                else if (item.keyType == 8) {
                    location.assign(`${item.url}`);
                }
                /* 名医主刀 */
                if (item.moduleType === 'anatomy') {
                    location.assign(`${hostPath}+ ${item.url}`);
                }
            }
        };
        /* const jump = url => {
          let link = document.createElement('a')
          link.href = url
          link.target = '_blank'
          link.click()
          link = null
        } */
        const searchJump = kw => {
            if (!isLogin) {
                userLogin();
                return;
            }
            searchText.value = kw;
            showList.value = true;
            /* 更新链接参数 */
            addQuery();
        };
        /* 获取科室id */
        const getDepIdFn = () => {
            if (isApp) {
                getDepId(userId).then((res) => {
                    if (res.code == 200) {
                        localStorage.setItem('search_depid', res.data.depId);
                        depId = res.data.depId;
                        getData();
                    }
                });
            }
            else {
                getDepId(userId).then((res) => {
                    if (res.code == 200) {
                        localStorage.setItem('search_depid', res.data.depId);
                        depId = res.data.depId;
                        getData();
                    }
                });
            }
        };
        // 保存用户搜索数据
        const saveSearchData = (obj) => {
            localStorage.setItem('searchData', JSON.stringify(obj));
        };
        onMounted(() => {
            /* 获取焦点 */
            nextTick(() => {
                inputRef.value.focus();
            });
            /* app中隐藏title */
            if (appPort()) {
                hiddenAppNavBar();
            }
            getDepIdFn();
            if (searchText.value) {
                isSearchFocus.value = false;
                showList.value = true;
            }
            else {
                isSearchFocus.value = true;
            }
        });
        onUnmounted(() => {
            localStorage.removeItem('search_depid');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _withDirectives(_createElementVNode("input", {
                            ref: (_value, _refs) => {
                                _refs['inputRef'] = _value;
                                inputRef.value = _value;
                            },
                            onKeydown: _withKeys(_withModifiers(search, ["prevent"]), ["enter"]),
                            onFocus: searchFocus,
                            onInput: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_unref(searchInput) && _unref(searchInput)(...args))),
                            type: "text",
                            name: "baike-search",
                            id: "search",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchText).value = $event)),
                            enterkeyhint: "search",
                            autocomplete: "off",
                            placeholder: "搜索"
                        }, null, 40, _hoisted_5), [
                            [_vModelText, searchText.value]
                        ]),
                        _withDirectives(_createElementVNode("div", {
                            class: "close-btn",
                            onClick: _withModifiers(closeSearch, ["stop"])
                        }, null, 8, _hoisted_6), [
                            [_vShow, searchText.value]
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: "cancel",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (backTo()), ["stop"]))
                    }, "取消")
                ]),
                (showList.value && searchText.value)
                    ? (_openBlock(), _createBlock(searchListItem, {
                        key: 0,
                        ref: (_value, _refs) => {
                            _refs['childRef'] = _value;
                            childRef.value = _value;
                        },
                        searchText: searchText.value,
                        onSaveSearchData: saveSearchData
                    }, null, 8, ["searchText"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass(["hot-history", 'isSearchFocus && !searchText ' ? 'linearDown' : ''])
                        }, [
                            (isHistory.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _hoisted_10,
                                        _createElementVNode("div", {
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (resetBtn()), ["stop"]))
                                        }, _hoisted_12)
                                    ]),
                                    _createElementVNode("ul", _hoisted_13, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value.words, (item, index) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                onClick: _withModifiers(($event) => (searchJump(item)), ["stop"])
                                            }, _toDisplayString(item), 9, _hoisted_14));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("ul", _hoisted_17, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotList.value, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: index,
                                            onClick: _withModifiers(($event) => (hotJump(item)), ["stop"])
                                        }, [
                                            _createElementVNode("i", _hoisted_19, _toDisplayString(index + 1), 1),
                                            _createTextVNode(_toDisplayString(item.keyword), 1)
                                        ], 8, _hoisted_18));
                                    }), 128))
                                ])
                            ], 512), [
                                [_vShow, hotList.value.length > 0]
                            ])
                        ], 512), [
                            [_vShow, isSearchFocus.value && !searchText.value]
                        ]),
                        _withDirectives(_createElementVNode("ul", {
                            class: _normalizeClass(["suggestion", '!isSearchFocus  && searchText ' ? 'linearDown' : ''])
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestList.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    class: "flex-c",
                                    key: index,
                                    onClick: _withModifiers(($event) => (suggestJump(item)), ["stop"])
                                }, [
                                    _hoisted_21,
                                    _createElementVNode("span", {
                                        class: "suggestion-text",
                                        innerHTML: item
                                    }, null, 8, _hoisted_22)
                                ], 8, _hoisted_20));
                            }), 128))
                        ], 512), [
                            [_vShow, !isSearchFocus.value && searchText.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("div", _hoisted_24, "没有搜索到相关内容", 512), [
                                [_vShow, isEmpty.value]
                            ])
                        ], 512), [
                            [_vShow, searchText.value && isEmpty.value]
                        ])
                    ]))
            ]));
        };
    }
});
